/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Preferred Slovenian accounting export format.
 * @nullable
 */
export type UpdateSloveniaTaxProfile200AccountingExportsPreferredFormat = typeof UpdateSloveniaTaxProfile200AccountingExportsPreferredFormat[keyof typeof UpdateSloveniaTaxProfile200AccountingExportsPreferredFormat] | null;


export const UpdateSloveniaTaxProfile200AccountingExportsPreferredFormat = {
  vod_xml: 'vod_xml',
  vasco_xml: 'vasco_xml',
  minimax_xml: 'minimax_xml',
} as const;
